<template>
    <div
        class="planning-droparea day-hour"
        :style="$options.getHourStyle(hour, date, itemId)"
        :data-date="date.formatted"
        :data-hour="hour"
        :data-itemid="itemId"
        @click.self="$options.handleClick(hour, date, itemId)"
        @contextmenu.self.prevent="$options.handleRightClick($event, date, itemId)"
        @mouseover="$options.handleMouseOver($event, date, itemId)"
        @drop="$options.handleDrop($event, date, hour, itemId)"
    >
        <component
            :is="$options.components.AbsenceComponent"
            v-for="absence in $options.absences(date, hour, itemId)"
            :key="date.formatted + absence.id + itemId"
            :absence="absence"
            :current-zoom="0"
        ></component>

        <component
            :is="$options.components.HourSlotComponent"
            v-for="itemSlotMapping in $options.getItemSlotMappingsForHour(
                itemSlotsMapping,
                hour,
            )"
            :key="date.formatted + itemSlotMapping.id"
            :item-slot-mapping="itemSlotMapping"
            :item-slots-group-mapping="itemSlotsGroupMapping"
            :item-id="itemId"
            :hour="hour"
            :date="date"
        ></component>
    </div>
</template>

<script>
import { ZOOM_SETTINGS } from '../../constants';
import { timeToMinutes } from '../../utils/timeToMinutes';
import store from '../../stores';
import HourSlotComponent from './HourSlotComponent';
import { emitter } from '../../plugins/Mitt';
import { filter } from 'lodash';
import AbsenceComponent from './AbsenceComponent';

const currentZoom = 0;

export default {
    components: {
        AbsenceComponent,
        HourSlotComponent,
    },
    props: {
        hour: {
            type: Number,
            required: true,
        },
        itemSlotsMapping: {
            type: Object,
            default() {
                return {};
            },
        },
        itemSlotsGroupMapping: {
            type: Object,
            default() {
                return {};
            },
        },
        itemId: {
            type: Number,
            required: true,
        },
        date: {
            type: Object,
        },
        weekscheduleColor: {
            type: String,
        },
    },
    getHourStyle(hour, date, itemId) {
        let background = null;
        const dayOfWeek = date.localDate.dayOfWeek().value();
        const width = ZOOM_SETTINGS[currentZoom].dayWidth[dayOfWeek] / 24;
        const position = {
            width: width + 'px',
        };

        const weekschedule = this.getWeekschedule(itemId, date);
        if (!weekschedule || !weekschedule.time_start || !weekschedule.is_working) {
            background = '#aaa';
            return {
                ...position,
                backgroundColor: background,
            };
        }
        const start = timeToMinutes(weekschedule.time_start);
        const end = timeToMinutes(weekschedule.time_end);

        const hourMinutes = hour * 60;

        if (start > hourMinutes || hourMinutes >= end) {
            background = '#aaa';
        }

        return {
            ...position,
            backgroundColor: background,
        };
    },
    getWeekschedule(itemId, date) {
        if (!itemId) {
            return '#FFF';
        }

        const defaultWeekschedule = store.state.planning.defaultWeekschedule;
        let day = defaultWeekschedule[date.formatted];

        const mode = store.state.planning.mode;

        if (['project'].includes(mode)) {
            const companyWeekSchedule = store.state.planning.companyWeekschedule;
            if (companyWeekSchedule[date.formatted]) {
                day = companyWeekSchedule[date.formatted];
            }
        }
        if (['person', 'team'].includes(mode)) {
            const itemsWeekschedule = store.state.planning.itemsWeekschedule;
            if (itemsWeekschedule[itemId] && itemsWeekschedule[itemId][date.formatted]) {
                day = itemsWeekschedule[itemId][date.formatted];
            }
        }

        return day;
    },
    handleClick(hour, date, itemId) {
        const weekScheduleDay = this.getWeekschedule(itemId, date);

        let eventObject = {
            dateStart: date.formatted,
            dateEnd: date.formatted,
            timeStart: ('0' + hour).slice(-2) + ':00',
            timeEnd: weekScheduleDay.time_end,
        };

        const mode = store.state.planning.mode;

        if (mode === 'project') {
            eventObject.taskId = itemId;
        } else if (mode === 'person') {
            eventObject.personId = itemId;
        }  else if (mode === 'equipment') {
            eventObject.equipmentId = itemId;
        } else if (mode === 'team') {
            eventObject.teamId = itemId;
        }
        emitter.emit('open-planning-form', eventObject);
    },
    handleRightClick($event, date, itemId) {
        window.removeEventListener('onmouseover', this.handleMouseOver);
        let eventObject = {
            date: date,
        };
        const mode = store.state.planning.mode;
        if (mode === 'project') {
            eventObject.taskId = itemId;
        } else if (mode === 'person') {
            eventObject.personId = itemId;
        } else if (mode === 'team') {
            eventObject.teamId = itemId;
        }
        emitter.emit('show-context-menu-component', { eventObject: eventObject, event: $event });
    },
    handleMouseOver($event, date, itemId) {
        if (store.state.planning.isDragging) {
            return;
        }
        let eventObject = {
            date: date,
        };

        const mode = store.state.planning.mode;

        if (mode === 'project') {
            eventObject.taskId = itemId;
        } else if (mode === 'person') {
            eventObject.personId = itemId;
        } else if (mode === 'team') {
            eventObject.teamId = itemId;
        }
        eventObject.mode = store.state.planning.mode;

        emitter.emit('show-day-hover-info', {
            eventObject: eventObject,
            event: $event,
        });
    },
    getItemSlotMappingsForHour(itemSlotMapping, hour) {
        return filter(itemSlotMapping, (slotMapping, slotId) => {
            const startMinutes = timeToMinutes(slotMapping.timeStart);
            const endMinutes = timeToMinutes(slotMapping.timeEnd);
            const currentHourMinutesStart = timeToMinutes(hour + ':00');
            const currentHourMinutesEnd = timeToMinutes(hour + 1 + ':00');
            return (
                startMinutes < currentHourMinutesEnd &&
                (startMinutes >= currentHourMinutesStart || endMinutes > currentHourMinutesStart)
            );
        });
    },
    absences(date, hour, itemId) {
        if (!itemId) {
            return;
        }

        const currentHourMinutesStart = timeToMinutes(hour + ':00');
        const currentHourMinutesEnd = timeToMinutes(hour + 1 + ':00');
        const minuteWidth =
            ZOOM_SETTINGS[0].dayWidth[date.localDate.dayOfWeek().value()] / (60 * 24);

        const mode = store.state.planning.mode;

        let absences = {};
        if (['project'].includes(mode)) {
            const defaultAbsences = store.state.planning.companyAbsences[date.formatted] ?? {};

            absences = filter(defaultAbsences, (absence) => {
                const startMinutes = timeToMinutes(absence.time_start);
                return (
                    startMinutes >= currentHourMinutesStart && startMinutes < currentHourMinutesEnd
                );
            });
        }

        if (['person', 'team'].includes(mode)) {
            const itemAbsences = store.state.planning.itemsAbsences[itemId] ?? {};
            const itemAbsencesForDate = itemAbsences[date.formatted] ?? {};
            absences = filter(itemAbsencesForDate, (absence) => {
                const startMinutes = timeToMinutes(absence.time_start);
                return (
                    startMinutes >= currentHourMinutesStart && startMinutes < currentHourMinutesEnd
                );
            });
        }
        absences = Object.values(absences);
        absences.sort((a, b) => {
            return a.time_start > b.time_start ? 1 : -1;
        });

        absences.map((absence) => {
            const startMinutes = timeToMinutes(absence.time_start);
            const duration = absence.duration;

            const minutesInHour = startMinutes - currentHourMinutesStart;

            absence.posStart = minutesInHour * minuteWidth;
            absence.width = duration * minuteWidth;
            return absence;
        });

        return absences;
    },
    handleDrop($event, date, hour, itemId) {
        let taskId = $event.dataTransfer.getData('taskId');
        let personId = $event.dataTransfer.getData('personId');
        if (!taskId && !personId) {
            return;
        }
        const weekScheduleDay = this.getWeekschedule(itemId, date);
        let eventObject = {
            dateStart: date.formatted,
            dateEnd: date.formatted,
            timeStart: ('0' + hour).slice(-2) + ':00',
            timeEnd: weekScheduleDay.time_end,
        };
        const mode = store.state.planning.mode;

        if (mode === 'project') {
            eventObject.taskId = itemId;
            eventObject.personId = personId;
        } else if (mode === 'person') {
            eventObject.personId = itemId;
            eventObject.taskId = parseInt(taskId);
        }  else if (mode === 'equipment') {
            eventObject.equipmentId = itemId;
            eventObject.taskId = parseInt(taskId);
        } else if (mode === 'team') {
            eventObject.teamId = itemId;
            eventObject.taskId = parseInt(taskId);
        }
        emitter.emit('open-planning-form', eventObject);
    },
};
</script>

<style>
.day-hour {
    position: relative;
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
    border-right: 1px solid #ccc;
}
.day-hour:hover {
    cursor: pointer;
}
</style>
